import { Button } from '../../../../Components/MUIs';
import CreateColumn from '../../../../Services/agGrid/createColumn';

/** sheGubun 코드 → 교육구분 표시명 (GridFilterButton용) */
const GetSheGubunFilterLabel = (data, sheGubunCodes) => {
  if (!data) return '';
  const code = data.sheGubun ?? data.SheGubun ?? '';
  if (code === '' || code == null) return '';
  const found = (sheGubunCodes || []).find((item) => item.code === code);
  return found ? found.name : String(code);
};

export const getColumnDefs1 = (props) => {
  const gridRef1 = props.gridRef1 || props.gridRef;

  return [
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 100,
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
      },
    }),

    CreateColumn(
      'sheGubun',
      '교육 구분',
      'left',
      200,
      true,
      true,
      false,
      'select',
      {
        width: 200,
        selectOptions: (props.codes?.sheGubun || []).map((v) => v.code),
        filterable: true,
        filterOptions: (props.codes?.sheGubun || []).map((v) => v.name),
        filterValueGetter: (params) =>
          GetSheGubunFilterLabel(params?.data, props.codes?.sheGubun),

        valueFormatter: (params) => {
          const found = props.codes?.sheGubun?.find(
            (item) => item.code === params.value
          );
          return found ? found.name : '';
        },

        cellClassRules: {
          'required-cell': (params) =>
            !params.value || params.value.toString().trim() === '',
        },
      }
    ),

    CreateColumn('sheNm', '교육명', 'left', 350, true, true, false, 'text', {
      minWidth: 350,
      flex: 2,
      cellEditor: 'agTextCellEditor',
      cellEditorParams: { maxLength: 255 },
      valueParser: (params) => {
        if (!params.newValue) return '';
        const value = params.newValue.toString().trim();
        return value.length > 255 ? value.substring(0, 255) : value;
      },
      cellClassRules: {
        'required-cell': (params) =>
          !params.value || params.value.toString().trim() === '',
      },
    }),

    CreateColumn(
      'sheTargetCount',
      '교육대상자',
      'left',
      260,
      false,
      true,
      false,
      'text',
      {
        minWidth: 260,
        editable: false,
        autoHeight: true,
        wrapText: true,
        cellRenderer: (e) => {
          if (!e.data) return null;

          const targetCount = e.data.sheTargetCount || 0;
          const targetText = e.data.eduTarget || '';
          const hasTarget = targetCount > 0 || !!targetText;

          if (!hasTarget) {
            return (
              <Button
                size="small"
                variant="contained"
                name="설정하기"
                onClick={() => props.PopupClickEventTarget?.(e.data)}
                sx={{ width: '100%' }}
              />
            );
          }

          const displayText = targetText || `${targetCount}명`;

          return (
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
              }}
            >
              <span
                style={{
                  padding: '8px 6px',
                  cursor: 'pointer',
                  color: '#1976d2',
                  textDecoration: 'underline',
                  flex: 1,
                  minWidth: 0, // flex 영역에서 wrapping을 위해 필요
                  overflow: 'visible',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  lineHeight: 1.2,
                }}
                onClick={() => props.PopupClickEventTarget?.(e.data)}
              >
                {displayText}
              </span>
              <Button
                size="small"
                variant="outlined"
                name="재설정"
                onClick={() => props.PopupClickEventTarget?.(e.data)}
                sx={{ minWidth: '60px', flexShrink: 0 }}
              />
            </div>
          );
        },
        cellClassRules: {
          'required-cell': (params) =>
            (!params.data?.sheTargetCount ||
              params.data?.sheTargetCount === 0) &&
            !params.data?.eduTarget &&
            !params.data?.eduTargetIds,
        },
      }
    ),

    CreateColumn(
      'sheTime',
      '교육 시간(시간)',
      'center',
      120,
      true,
      true,
      false,
      'number',
      {
        width: 120,
        cellEditor: 'agNumberCellEditor',
        cellEditorParams: {
          onCellEditorCreated: (params) => {
            const getInput = () =>
              params.eInput ||
              document.querySelector('input.ag-input-field-input');

            const setupInput = () => {
              const input = getInput();
              if (!input) {
                setTimeout(setupInput, 10);
                return;
              }

              const handleKeyDown = (e) => {
                const allowedKeys = [
                  'Backspace',
                  'Delete',
                  'ArrowLeft',
                  'ArrowRight',
                  'ArrowUp',
                  'ArrowDown',
                  'Tab',
                  'Enter',
                  'Home',
                  'End',
                ];
                const isNumberKey = e.key >= '0' && e.key <= '9';

                if (
                  !isNumberKey &&
                  !allowedKeys.includes(e.key) &&
                  !e.ctrlKey &&
                  !e.metaKey
                ) {
                  e.preventDefault();
                  e.stopPropagation();
                  return false;
                }
              };

              const handleInput = () => {
                let val = input.value.replace(/[^0-9]/g, '');
                if (val.length > 10 || parseInt(val) > 2147483647)
                  val = '2147483647';
                input.value = val;
              };

              input.addEventListener('keydown', handleKeyDown);
              input.addEventListener('input', handleInput);
            };

            setupInput();
          },
        },
        valueParser: (params) => {
          const raw = params.newValue?.toString().replace(/[^0-9]/g, '') || '';
          const parsed = parseInt(raw, 10);
          if (isNaN(parsed)) return null;
          return Math.min(parsed, 2147483647);
        },
        cellClassRules: {
          'required-cell': (params) =>
            !params.value || params.value.toString().trim() === '',
        },
      }
    ),

    CreateColumn(
      'sheYn',
      '교육 실시 여부',
      'center',
      120,
      true,
      false,
      false,
      'select',
      {
        width: 120,
        selectOptions: ['ON', 'OFF'],
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
